// extracted by mini-css-extract-plugin
export default {"tableRow":"zone_tableRow__P51Ke","tableCell":"zone_tableCell__HXKpI"};